'use client'

import { useEffect } from 'react'
import useHash from '@/hooks/useHash'
import { scrollToSection } from '@/lib/utils'

// Tiny client island: scroll to the #hash section on deep-link. No data, renders nothing.
export default function HashScroll() {
  const hash = useHash()

  useEffect(() => {
    if (!hash) return
    scrollToSection({ id: hash, offset: { mobile: 130, desktop: 80 } })
  }, [hash])

  return null
}
